class TableEngine {
    constructor(selector, options = {}) {
        this.selector = selector;
        this.options = this.normaliseOptions(options);
        this.table = null;
        this.buildStructure();
        this.cacheElements();
        this.attachRetry();
        this.load();
    }

    normaliseOptions(options) {
        return {
            ajax: options.ajax || null,
            method: options.method || 'GET',
            dataField: options.dataField || 'data',
            columns: options.columns || [],
            order: options.order || [[0, 'asc']],
            pageLength: options.pageLength || 10,
            searchPlaceholder: options.searchPlaceholder || 'Search…',
            dom: options.dom || 'lfrtip',
            searching: options.searching,
            beforeLoad: options.beforeLoad || null,
            afterLoad: options.afterLoad || null,
            drawCallback: options.drawCallback || null,
            onError: options.onError || null,
            xhrFields: options.xhrFields || null,
            dataTableOptions: options.dataTableOptions || null
        };
    }

    buildStructure() {
        const wrapper = $(this.selector);

        let skeletonRows = '';

        for (let i = 0; i < 4; i++) {
            skeletonRows += this.generateSkeletonRow();
        }

        wrapper.addClass('table-container position-relative');
        wrapper.html(`
            <div class="table-skeleton py-4 px-3 d-none">
                ${skeletonRows}
            </div>

            <div class="table-loader-overlay d-none">
                <div class="spinner-border text-primary"></div>
                <p class="text-muted mt-3">Loading…</p>
            </div>

            <div class="table-error text-center py-5 d-none">
                <div class="mb-3">
                    <i class="fa-solid fa-triangle-exclamation text-warning" style="font-size:2.6rem;"></i>
                </div>
                <h5 class="fw-semibold text-dark mb-2">Unable to Load Data</h5>
                <p class="text-muted mb-3">Something went wrong. You may try again.</p>
                <button class="btn btn-outline-primary px-4 retry-btn">Try Again</button>
            </div>

            <div class="table-wrapper d-none">
                <div class="table-responsive table-scroll-wrapper">
                    <table class="table table-striped dataTable-element w-100"></table>
                </div>
            </div>
        `);
    }

    generateSkeletonRow() {
        const columnCount = this.options.columns.length;
        let row = '<div class="skeleton-table-row mb-3">';

        for (let i = 0; i < columnCount; i++) {
            row += `
                <div class="skeleton-table-cell flex-grow-1">
                    <div class="skeleton-line w-75 mb-2"></div>
                    <div class="skeleton-line w-50 mb-2"></div>
                    <div class="skeleton-line w-100"></div>
                </div>
            `;
        }

        row += '</div>';
        return row;
    }

    cacheElements() {
        this.container = $(this.selector);
        this.loading = this.container.find('.table-loading');
        this.error = this.container.find('.table-error');
        this.wrapper = this.container.find('.table-wrapper');
        this.tableElement = this.container.find('.dataTable-element');
        this.skeleton = this.container.find('.table-skeleton');
        this.loader = this.container.find('.table-loader-overlay');
    }

    load() {
        this.showLoading();

        this.options.beforeLoad?.();

        const ajaxUrl =
            typeof this.options.ajax === 'function'
                ? this.options.ajax()
                : this.options.ajax;

        const ajaxOpts = {
            url: ajaxUrl,
            method: this.options.method,
            dataType: 'json',
            success: (res) => {
                const data = res[this.options.dataField];

                if (!res.success || !Array.isArray(data)) {
                    return this.showError(res);
                }

                this.initTable(data);
                this.options.afterLoad?.(data);
            },
            error: (xhr) => this.showError(xhr)
        };
        if (this.options.xhrFields) {
            ajaxOpts.xhrFields = this.options.xhrFields;
        }
        $.ajax(ajaxOpts);
    }

    initTable(data) {
        this.hideLoading();

        if ($.fn.DataTable.isDataTable(this.tableElement)) {
            this.table.clear().rows.add(data).draw();
            return;
        }

        const dtOptions = {
            data,
            columns: this.options.columns,
            order: this.options.order,
            pageLength: this.options.pageLength,
            dom: this.options.dom,
            searching: this.options.searching !== false,
            responsive: this.options.responsive,
            language: {
                search: "",
                searchPlaceholder: this.options.searchPlaceholder
            }
        };
        if (this.options.drawCallback) {
            dtOptions.drawCallback = this.options.drawCallback;
        }
        if (this.options.searching === false) {
            dtOptions.layout = { topEnd: null };
        }
        if (this.options.dataTableOptions && typeof this.options.dataTableOptions === "object") {
            Object.assign(dtOptions, this.options.dataTableOptions);
        }
        this.table = this.tableElement.DataTable(dtOptions);
    }

    showLoading() {
        this.skeleton.removeClass('d-none');
        this.loader.removeClass('d-none');
        this.error.addClass('d-none');
        this.wrapper.addClass('d-none');
    }

    hideLoading() {
        this.skeleton.addClass('d-none');
        this.loader.addClass('d-none');
        this.error.addClass('d-none');
        this.wrapper.removeClass('d-none');
    }

    showError(err) {
        this.skeleton.addClass('d-none');
        this.loader.addClass('d-none');
        this.wrapper.addClass('d-none');
        this.error.removeClass('d-none');
    }

    reload() {
        this.load();
    }

    attachRetry() {
        this.container.on('click', '.retry-btn', () => this.reload());
    }
}

window.TableEngine = TableEngine;